export default __webpack_public_path__ + "static/media/icons-user-green-32-px.cfb0e849.svg";